/**
 * Created by ravikumar.r on 16/12/17.
 */
import styled from 'styled-components';
import { colors } from '../../colorCodes';

const IconMenuContainer = styled.div`
    position: relative;
    display: inline-block;
    ul {
        font-family: inherit;
        list-style-type: none;
        margin: 0;
        padding: 0;
        width: ${props => props.width || '100px'};
        background-color: ${colors.whiteText};
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        transition: 0.3s;
        position: absolute;
        top: 0;
    }

    li {
        display: block;
        color: ${colors.greyTableHeaderText};
        padding: 8px 16px;
        text-decoration: none;
    }

    li:hover {
        background-color: ${colors.greyBorder};
        color: ${colors.greyTableHeaderText};
        cursor: pointer;
    }
    .more-icon {
        cursor: pointer;
        top: 6px;
        left: 20px;
        position: relative;
        font-size: 30px;
        display: inline-block;
    }
`;
export default IconMenuContainer;
